import styled from 'styled-components';
import { border, space, layout, position, color } from 'styled-system';
import theme, { colors } from '@styles/theme';

export const Card = styled('div')(
  {
    backgroundColor: colors.grayscale.white,
    border: theme.borders.divider,
    borderRadius: '4px',
    boxSizing: 'border-box',
    maxWidth: 'calc(100vw - 2rem)',
    width: '100%'
  },
  border,
  space,
  layout,
  position,
  color
);

Card.displayName = 'Card';
export default Card;
